import React from 'react';
import PropTypes from 'prop-types';

const ScheduleCampaignFooter = ({ scheduleCampaign, close, submitting }) => (
  <div className="u-p o-flexbox">
    <button
      className="c-btn c-btn--grey u-1/3"
      type="button"
      onClick={close}
      disabled={submitting}
    >
      Cancel
    </button>
    <button
      className="c-btn u-1/3"
      type="button"
      onClick={scheduleCampaign}
      disabled={submitting}
    >
      Schedule
    </button>
  </div>
);

ScheduleCampaignFooter.propTypes = {
  scheduleCampaign: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

ScheduleCampaignFooter.defaultProps = {
  isRecurringCampaign: false,
};

export default ScheduleCampaignFooter;
